import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel } from '../../../toolkit/uicomponent';
import { CreateAccountComponentProps, CreateAccountComponentHandler, CreateAccountComponentState } from './createaccountcomponent';
import { CreateAccountCSSStyle } from './createaccountcss';
import * as React from 'react';
import { Strings } from '../../../../utils/resources/strings';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../popup/confirmrequest/confirmrequestconfirmbuttoncss';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { MultiselectCategoryListComponent } from './categorylist/multiselectcategorylistcomponent';
import { CategoryDto } from '../../../../core/dto/categories/categorydto';
import { FloatingTextComponent } from '../../../toolkit/floatingtext/floatingtextcomponent';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { CreateAccountDtoImpl, CreateAccountDto } from '../../../../core/dto/createaccount/createaccountdto';
import { MSISDNValidation } from '../../../toolkit/msisdnvalidation/msisdnvalidation';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { CreateAccountOTPMessageComponent } from '../createaccountotp/createaccountotpmessagecomponent/createaccountotpmessagecomponent';

import './create-account-style.css';

export class CreateAccountViewImpl extends UIComponentViewImpl<UIDataModel>
{
    popUpComponent: PopUpWrapperComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;
    private numberComponent: any;
    private passwordComponent1: any;
    private passwordComponent2 :any;
    private categoryListComponent: any;

    bindHandlers()
    {
        this.onLoginButtonClick = this.onLoginButtonClick.bind(this);
        this.onSignUpClick = this.onSignUpClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.onLogoClicked = this.onLogoClicked.bind(this);
    }
    

    draw(props: CreateAccountComponentProps, state: CreateAccountComponentState, cssStyle: CreateAccountCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

     return (
         <>
        {
            state.isOtpSuccess && <CreateAccountOTPMessageComponent sectoken={state.sectoken} msisdn={state.msisdn} routeNextFeature={props.routeNextFeature} context={this.getUIProps().context}/>}
        { !state.isOtpSuccess &&
            <div id="create-account-wrapper" style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getInnerWrapperCSSStyle()}>
                    {/* <img onClick={this.onLogoClicked} style={{cursor: "pointer",width:'100%',height:"80px",marginBottom:'45px',marginTop:'0px',marginLeft:'-150px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  /> */}
                    <img id="create-account-page-logo" onClick={this.onLogoClicked} style={{cursor: "pointer",width:'auto', marginBottom:'45px',marginTop:'0px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
                    <label id="create-account-page-heading" style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.create_account)}</label>
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                         <MsisdnFloatingTextComponent hint={this.getContext().getResources().getString(Strings.mobilenumberhint)} maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.numberComponent = item} id={"#mobileNumber"} value={props.context.getUserContext().getMsisdn()} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.mobilenumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
                    </div>
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                    <FloatingTextComponent hint={this.getContext().getResources().getString(Strings.password)} maxLength={this.getUIProps().context.getResources().getString(Strings.passwordMaxLength)} ref={(item: any) => this.passwordComponent1 = item} id={"#password"} value={props.context.getUserContext().getPassword()} inputType={"password"} isRequired={true} placeholder={props.context.getResources().getString(Strings.password)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.passwordIncorrect)}/>
                    </div>
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                    <FloatingTextComponent hint={this.getContext().getResources().getString(Strings.password)} maxLength={this.getUIProps().context.getResources().getString(Strings.passwordMaxLength)} ref={(item: any) => this.passwordComponent2 = item} id={"#confirmPassword"} value={props.context.getUserContext().getPassword()} inputType={"password"} isRequired={true} placeholder={props.context.getResources().getString(Strings.confirm_password)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.passwordIncorrect)}/>
                    </div>
                    <div id="create-account-page-categ-wrapper" style={cssStyle.getCategoriesCSSStyle()}>
                        <MultiselectCategoryListComponent seletedCategories={[]} title={props.context.getResources().getString(Strings.select_categories)} isEditable={true} ref={(item: any) => this.categoryListComponent = item} listOfDatas={[]} context={props.context}/>
                    </div>
                    <div style={cssStyle.getLoginButtonCSSStyle()}>
                        <ButtonComponent onClick={this.onSignUpClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)}  context={props.context} label={props.context.getResources().getString(Strings.signup)}/>
                    </div>
                    <br/>
                    <div style={cssStyle.getSignUpRowDivCSSStyle()}>
                        <label style={cssStyle.getDoUHaveAccountCSSStyle()}>{props.context.getResources().getString(Strings.haveanaccount)}</label>
                        <label onClick={this.onLoginButtonClick} style={cssStyle.getSignUpCSSStyle()}>{props.context.getResources().getString(Strings.login)}</label>
                    </div>
                </div>
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
              
                <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            </div>
        }
        </>
        );
    }

    getUIComponentHandler(): CreateAccountComponentHandler
    {
        return super.getUIComponentHandler() as CreateAccountComponentHandler;
    }

    validateData(): void
    {
        console.log("validate"+this.getUIProps().context.getResources().getString(Strings.regular_expression));
        var passwordReg = new RegExp(this.getUIProps().context.getResources().getString(Strings.regular_expression));
        // if(this.numberComponent.validate())
        // {
        //     let numberMinLength = +this.getUIProps().context.getResources().getString(Strings.numberMinLength);
        //     let numbermaxLength = +this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

        //     if(this.numberComponent.getData().length < numberMinLength 
        //                     || this.numberComponent.getData().length > numbermaxLength)
        //     {
        //         this.numberComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
        //         return false;
        //     }
            
        //     return true;
        // }

        if(this.numberComponent.validate()  && this.passwordComponent1.validate() && this.passwordComponent2.validate())
        {
           
            let passwordMinLength = +this.getUIProps().context.getResources().getString(Strings.passwordMinLength);
            let passwordmaxLength = +this.getUIProps().context.getResources().getString(Strings.passwordMaxLength);

            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.numberComponent.getData());
                let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
                let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

    
                if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
                {
                    console.log("msisdn validation");
                    this.numberComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                  
                }
             
             else if(this.passwordComponent1.getData().length < passwordMinLength 
                        || this.passwordComponent1.getData().length > passwordmaxLength)
            {
                console.log("p1 validation");
                this.passwordComponent1.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
               
            }
            else if(!passwordReg.test(this.passwordComponent1.getData()))
            {
                console.log("p1 regex validation"+this.passwordComponent1.getData());
                this.passwordComponent1.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.incorrectpasswordpolicy));
             
            }

             else if(this.passwordComponent2.getData().length < passwordMinLength 
                        || this.passwordComponent2.getData().length > passwordmaxLength)
            {
                console.log("p2 validation");
                this.passwordComponent2.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
             
            }
            else if(!passwordReg.test(this.passwordComponent2.getData()))
            {
                console.log("p2 regex validation");
                this.passwordComponent2.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.incorrectpasswordpolicy));
              
            }
            else if(this.passwordComponent1.getData() !== this.passwordComponent2.getData())
            {
                console.log("comparison validation");
                this.passwordComponent2.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.confirmedpasswordmismatch));
               
            }
            else if (this.categoryListComponent.getSelectedMultiselectCategoryList().length === 0)
            {
                this.showPopup("",this.getUIProps().context.getResources().getString(Strings.categories_error_msg),AlertType.WARN);
            }
            else{
                console.log("sign up");
                (this.getUIComponentHandler() as CreateAccountComponentHandler).onSignUp();
                         }
               
        }
       }

    updateCategoriesData(listOfDatas: CategoryDto[])
    {
        this.categoryListComponent.updateListData(listOfDatas);
    }
    protected onLogoClicked()
    {
        (this.getUIComponentHandler() as CreateAccountComponentHandler).onLogoClicked();
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    getData(): CreateAccountDto
    {
        let request = new CreateAccountDtoImpl();
        request.setMsisdn(this.numberComponent.getData());
        request.setEmail("");
        request.setLanguage(this.getUIProps().context.getUserContext().getLanguage());
        request.setPassword(this.passwordComponent1.getData());
        console.log(this.categoryListComponent.getSelectedMultiselectCategoryList());
        request.setCategoryId(this.categoryListComponent.getSelectedMultiselectCategoryList());

        return request;
    }
    closePopup()
    {
        this.popUpComponent.setShowWindow(false, <></>);
    }

    showPopup(id:string,msg:string,type:AlertType):void
    {
      
    this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

    }
    
    private onLoginButtonClick()
    {
        (this.getUIComponentHandler() as CreateAccountComponentHandler).onLoginButtonClick();
    }
 
    private onSignUpClick()
    {
        (this.getUIComponentHandler() as CreateAccountComponentHandler).onSignUpClick();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/createaccountview.tsx